import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=13277499&"
import script from "./groupDetail.vue?vue&type=script&lang=js&"
export * from "./groupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "groupDetail.vue"
export default component.exports